export const removeDuplicateObjects = (arr, property) => {
  const seenIds = new Set();
  const uniqueArray = [];

  for (const obj of arr) {
    if (!seenIds.has(obj[property])) {
      seenIds.add(obj[property]);
      uniqueArray.push(obj);
    }
  }

  return uniqueArray;
}
